// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"TheHeader_logoWrapper_3Vo_W","logo":"TheHeader_logo_2g0af"};